import React from "react";
import Button from "@mui/material/Button";
import PersonIcon from "@mui/icons-material/Person";

const UserIdButton = ({
  onClick,
  name = "User ID",
  icon = <PersonIcon />,
  sx = {},
  ...props
}) => (
  <Button
    variant="contained"
    onClick={onClick}
    startIcon={icon || undefined}
    sx={{
      background:
        "#02462E",
      width: 160,
      height: 50,
      borderRadius: "10px",
      color: "#fff",
      textTransform: "none",
      "&:hover": {
        background:
          "#02462E",
      },
      ...sx,
    }}
    {...props}
  >
    {name}
  </Button>
);

export default UserIdButton;
